import styled from '@emotion/styled';

export const TabItem = styled('li', { label: 'TabItem' })<{active: boolean}>`
    background-color: ${({active}): string => active ? '#339933' : '#ccc'};
    margin: 0;
`;

export const TabButton = styled('button', { label: 'TabButton' })<{active: boolean}>`
    border-radius: 0;
    color: #fff;
    border: 1px solid #fff;
    background-color: ${({active}): string => active ? '#339933' : '#ccc'};
    padding: 10px 5px;
    text-align: left;
    margin-right: 3px;
    width: 100%;
    max-width: calc(100% + 20px);
    white-space: nowrap;

    &:hover {
        ${({active}): string => active ? '' : 'background: #bbb;'};
        cursor: pointer;
    }
`;
